import React from 'react';

interface TabOption {
  id: string;
  label: string;
  icon: React.ReactNode;
}

interface InterviewTabsProps {
  tabs: TabOption[];
  activeTab: string;
  onChange: (id: string) => void;
}

export const InterviewTabs: React.FC<InterviewTabsProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="w-full md:w-64 border-r border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 shrink-0 flex flex-row md:flex-col overflow-x-auto md:overflow-x-visible items-start py-4 lg:py-6 px-4 md:px-0 gap-2 md:gap-1 z-0 relative">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`w-max md:w-full flex items-center shrink-0 px-4 py-2.5 text-sm font-medium transition-all relative overflow-hidden md:rounded-r-full hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-100 cursor-pointer ${
              isActive
                ? 'text-emerald-700 dark:text-emerald-300 bg-emerald-100 dark:bg-emerald-900/40 hover:bg-emerald-100 dark:hover:bg-emerald-900/40'
                : 'text-slate-600 dark:text-slate-400'
            }`}
          >
            {isActive && (
               <div className="hidden md:block absolute left-0 top-0 bottom-0 w-1 bg-emerald-500 dark:bg-emerald-400 rounded-r" />
            )}
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
